import api from '@/api';
import { API_BASE_URL } from '../../index';
import { QuestReportInvoiceRequest } from './Invoice.types';

const CONTROLLER_URL = `${API_BASE_URL}/Reports`;

export async function getQuestReportInvoiceRequest(
  params: QuestReportInvoiceRequest,
) {
  const result = (await api.getReport(
    `${CONTROLLER_URL}/Invoice`,
    params,
  )) as unknown;

  return result as BlobPart;
}
